A partner-provided unique ID for the consent component.

This can be used to correlate the consent component back to its corresponding representation in your software.
This must be unique across all components in the questionnaire.
